import ProgressiveVideoLoader from 'CoreComponents/progressiveVideoLoader/';

document.querySelectorAll('.list-media__card--video').forEach(videoCard => {
  const loader = new ProgressiveVideoLoader(videoCard);

  loader.load();
});
